module.exports = __webpack_public_path__ + "img/portifolio_empilhadeiras.dd9099ba.jpg";